import {
  GET_CALL_STICKY_COLUMNS,
  GET_CALL_STICKY_COLUMNS_SUCCESS,
  GET_CALL_STICKY_COLUMNS_ERROR,
  UPDATE_CALL_STICKY_COLUMNS,
  UPDATE_CALL_STICKY_COLUMNS_SUCCESS,
  UPDATE_CALL_STICKY_COLUMNS_ERROR
} from "./actionTypes"

export const getCallStickyColumns = () => {
  return {
    type: GET_CALL_STICKY_COLUMNS,
  }
}

export const getCallStickyColumnsSuccess = sticky_columns => {
  return {
    type: GET_CALL_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const getCallStickyColumnsError = error => {
  return {
    type: GET_CALL_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}

export const updateCallStickyColumns = (sticky_columns) => {
  return {
    type: UPDATE_CALL_STICKY_COLUMNS,
    payload: sticky_columns,
  }
}

export const updateCallStickyColumnsSuccess = sticky_columns => {
  return {
    type: UPDATE_CALL_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const updateCallStickyColumnsError = error => {
  return {
    type: UPDATE_CALL_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}